import { GetterTree } from 'vuex'
import UserState from './states'
import store, { State } from '@/store/store'
import { ELevel } from '@/services/Menus'
import _ from 'lodash'

const getters: GetterTree<UserState, State> = {
  headerLists: (state) => {
    return state.list.column
  },
  userLists: (state) => {
    const data = state.list.result
    const result: Array<{
      text?: string,
      value?: string,
      name?: string,
      userData?: any,
    }> = []
    data.forEach((each) => {
      result.push({
        text: each.prefix + each.firstname + ' ' + each.lastname,
        name: each.prefix + each.firstname + ' ' + each.lastname,
        value: each._id,
        userData: each,
      })
    })
    return result
  },
  leaderHeader: (state) => {
    return state.listLeader.column
  },
  leaderListsByRole: (state) => {
    return state.listLeader.result
  },
  itemLists: (state) => {
    return state.list.result
  },
  staffItemLists: (state) => {
    const data = state.listStaff.result
    return data
  },
  staffHeaders: (state) => {
    return state.listStaff.column
  },
  staffPagination: (state) => {
    const paginationLists = {
      itemCount: state.listStaff.itemCount,
      page: state.listStaff.page,
      pageCount: state.listStaff.pageCount,
    }
    return paginationLists
  },
  filterLists: (state) => {
    return state.list.defaultFilter
  },
  pagination: (state) => {
    const paginationLists = {
      itemCount: state.list.itemCount,
      page: state.list.page,
      pageCount: state.list.pageCount,
    }
    return paginationLists
  },
  headerListsByRole: (state) => {
    return state.listCaregiver.column
  },

  headerListsCaregiver: () => {
    const column = store.getters['components/level'].mode === ELevel.ADMIN ? [
      {
        text: 'ศูนย์บริการ',
        value: 'centerId',
      },
    ] : []
    return [
      ...column,
      {
        text: 'ชื่อ นามสกุล',
        value: 'firstname',
      },
      {
        text: 'เบอร์โทรศัพท์',
        value: 'phone',
        sortable: false,
      },
      {
        text: 'วัน/เดือน/ปีเกิด',
        value: 'birthdate',
      },
      {
        text: 'ที่อยู่',
        value: 'address',
      },
      {
        text: 'หลักสูตร',
        value: 'caregiverLevel',
      },
      // {
      //   text: 'รหัสนักบริบาล',
      //   value: 'caregiverId',
      // },
      {
        text: 'ภาษา',
        value: 'language',
        sortable: false,
      },
      {
        text: 'ประสบการณ์',
        value: 'experience',
        sortable: false,
      },
      {
        text: 'จัดการ',
        value: 'action',
        sortable: false,
      },
    ]
  },
  userListsByRole: (state) => {
    const data = state.listCaregiver.result
    const result: Array<{
      text?: string,
      value?: string,
      name?: string,
    }> = []
    data.forEach((each) => {
      result.push({
        text: each.prefix + each.firstname + ' ' + each.lastname,
        name: each.prefix + each.firstname + ' ' + each.lastname,
        value: each._id,
      })
    })
    return result
  },
  userById: (state) => {
    return _.mapKeys(state.list.result, '_id')
  },
  caregiverListsByRole: (state) => {
    return state.listCaregiver.result
  },
  filterListsByRole: (state) => {
    return state.listCaregiver.defaultFilter
  },
  paginationCaregiver: (state) => {
    const paginationLists = {
      itemCount: state.listCaregiver.itemCount,
      page: state.listCaregiver.page,
      pageCount: state.listCaregiver.pageCount,
    }
    return paginationLists
  },
  paginationLeader: (state) => {
    const paginationLists = {
      itemCount: state.listLeader.itemCount,
      page: state.listLeader.page,
      pageCount: state.listLeader.pageCount,
    }
    return paginationLists
  },
}

export default getters
